module.exports = __webpack_public_path__ + "static/media/accessories1.82bc9c95.jpg";